export default {
  id: 225,
  title: 'Target #225 - Spark',
  url: 'https://cssbattle.dev/play/225',
  colors: ['#343848', '#E25C57', '#F4DA64'],
  solution:
    '<p a><p b><p c><style>p[a],p[b]{background:#e25c57}p[b],p[c]{left:180;width:40}p[a],p[c]{top:50;height:40}body{background:#343848}p{position:fixed;margin:0}p[a]{left:0;width:140;box-shadow:260px 0 #e25c57}p[b]{top:210;height:90}p[c]{rotate:45deg;background:#f4da64;box-shadow:28px 85px #f4da64,85px 28px #f4da64',
}
